<template>
  <div class="kk-settings_menu">
    <nav-header :title="$t('sidebar.settings')"></nav-header>
    <!-- Body -->
    <div v-if="Object.keys(treeHashTable).length > 0" class="kk-settings_menu__tree" @click="click">
      <item
        v-for="item in settingsMenu"
        :id="item.id"
        :key="item.id"
        :editable="false"
        :hash-table="treeHashTable"
        :draggable="false"
        :is-active="activeTab === item.id"
      />
    </div>
  </div>
</template>
<script>
import Item from "../redZone/content/Item.vue";
import NavHeader from "../redZone/content/RedZoneHeader.vue";
import Tree from "../../store/panel/Tree";

const getItemId = (e) => {
  const node = e.target.closest(".kk-tree__title");
  if (!node) return;
  return node.dataset.id;
};

export default {
  components: {
    NavHeader,
    Item,
  },
  data() {
    return {
      settingsMenu: [
        {
          children: [],
          expanded: false,
          id: 1,
          level: 1,
          parents: [],
          title: this.$t("setting.menu.general"),
          type: "",
        },
        {
          children: [],
          expanded: false,
          id: 2,
          level: 1,
          parents: [],
          title: this.$t("setting.menu.advanced"),
          type: "",
        },
        {
          children: [],
          expanded: false,
          id: 3,
          level: 1,
          parents: [],
          title: this.$t("setting.menu.accessibility"),
          type: "",
        },
        {
          children: [],
          expanded: false,
          id: 4,
          level: 1,
          parents: [],
          title: this.$t("setting.menu.quickAccsToolbar"),
          type: "",
        },
      ],
      treeHashTable: {},
    };
  },
  computed: {
    activeTab() {
      return this.$store.state.preferences.settingsActiveTab;
    },
  },
  mounted() {
    this.$store.dispatch("preferences/setSettingActiveTab", { id: 4 });
    const allData = {
      id: "ROOT",
      title: "root",
      expanded: true,
      type: "folder",
      children: this.settingsMenu,
    };
    const tree = new Tree(allData);
    this.treeHashTable = tree.getHashTable(allData);
  },
  methods: {
    click(e) {
      const id = getItemId(e);
      if (!id) return;

      this.$store.dispatch("preferences/setSettingActiveTab", { id: +id });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/styles/variables.less";
.kk-settings_menu {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__tree {
    padding-top: 0.4rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
